'use strict';

(function () {
  'use strict';

  angular.module('msActivities').controller('ActivitySectionCtrl', ActivitySectionCtrl);

  ActivitySectionCtrl.$inject = ['$scope', '$log', '$timeout', 'section', 'activityRouter', 'eventTrackingSvc'];

  /* @ngInject */
  function ActivitySectionCtrl($scope, $log, $timeout, section, activityRouter, eventTrackingSvc) {
    var vm = this;
    vm.title = 'ActivitySectionCtrl';
    vm.$onInit = activate;

    ////////////////

    function activate() {
      $log.debug('ActivitySectionCtrl ctrl activate');
      vm.section = section;

      eventTrackingSvc.fireEvent('activity', 'viewSection', $scope.activityVm.activity.url + '::' + section.id, {
        activity: section.activityId,
        currentSection: section.id
      });

      if ($scope.activityVm.activity.publicView && section.position === 1) {
        eventTrackingSvc.fireEvent('activity', 'publicStart', $scope.activityVm.activity.url);
        focusMainContent();
      } else {
        focusActivityDetail();
      }
    }

    $scope.quizNext = function () {
      //see if there is a widget "Next", go to that section
      //otherwise, call save() to finish activity
      var nextWidget = vm.section.widgets.filter(function (widget) {
        return widget.type === 'button/next_button';
      });
      if (nextWidget.length === 1) {
        $scope.next(nextWidget[0].properties.nextSection);
      } else {
        //call save() defined on activityCtrl
        $scope.save();
      }
    };

    $scope.next = function (nextSection) {
      eventTrackingSvc.fireEvent('activity', 'nextSection', $scope.activityVm.activity.url + '::' + $scope.findSection(nextSection).id, {
        activity: section.activityId,
        currentSection: section.id,
        nextSection: nextSection
      });
      activityRouter.nextSection({
        section: nextSection
      });
    };

    $scope.findSection = function (uuid) {
      return $scope.activityVm.activity.sections.filter(function (section) {
        return section.uuid === uuid;
      })[0];
    };

    // WCAG helper to set focus to activity container
    function focusActivityDetail() {
      $timeout(function () {
        var activityDetail = angular.element('.activity-content-wrapper');
        if (activityDetail && activityDetail[0]) {
          activityDetail[0].focus();
        }
      }, 100);
    }

    function focusMainContent() {
      $timeout(function () {
        var mainContent = angular.element('#mainContent');
        if (mainContent && mainContent[0]) {
          mainContent[0].focus();
        }
      }, 100);
    }
  }
})();